<div class="modal-primary" role="document">
    <div class="modal-content">
        <div class="modal-header borderBottom">
            <h4 class="modal-title sizef08200-title">{{content}}</h4>
            <button type="button" class="close" (click)="cancel()" aria-label="Close" style="padding: 0; margin: 0;">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <h4 class="pT20 dFlex thimg">
            <textarea class="reason" name="" id="" cols="30" rows="10" [(ngModel)]="data"
                placeholder="请输入封禁理由"></textarea>
        </h4>
        <div class="modal-footer">
            <div class="fhBtn2 dFlex2 marginB20">
                <button (click)="cancel()" class="bgf59c7d">取消</button>
            </div>
            <div class="fhBtn2 dFlex2 marginB20">
                <button (click)="confirm()" class="confirmBtn">确定</button>
            </div>
        </div>


    </div>
</div>